export default "__VITE_ASSET__CahQaW75__"